import { render, staticRenderFns } from "./about.vue?vue&type=template&id=488e1127&"
var script = {}
import style0 from "./about.vue?vue&type=style&index=0&id=488e1127&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports